// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackShippingInfoChangedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/account/trackShippingInfoChanged";

const useTrackShippingInfoChanged = (
    parameters: TrackShippingInfoChangedParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.shippingInfoChanged, parameters, options);
};

export default useTrackShippingInfoChanged;
